import { render, staticRenderFns } from "./SelectAudioSource.vue?vue&type=template&id=8b3b0b94&scoped=true&"
import script from "./SelectAudioSource.vue?vue&type=script&lang=js&"
export * from "./SelectAudioSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3b0b94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b3b0b94')) {
      api.createRecord('8b3b0b94', component.options)
    } else {
      api.reload('8b3b0b94', component.options)
    }
    module.hot.accept("./SelectAudioSource.vue?vue&type=template&id=8b3b0b94&scoped=true&", function () {
      api.rerender('8b3b0b94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/components/cards/form/SelectAudioSource.vue"
export default component.exports